import { translate, useDynamicData } from '@avensia/excite';
import { useWishListCount } from '@avensia/excite-commercetools/wishlist';
import { TestIdProps } from '@avensia/test-automation';
import { styled } from '@glitz/react';
import * as React from 'react';
import { ButtonLink } from 'webapp/components/button';
import { HeartIcon } from 'webapp/components/icons';
import { Theme } from 'webapp/theme';
import { addNavigationEventToDataLayer } from 'webapp/tracking/events/main-navigation';
import { NnTestIdProps } from 'webapp/shared/test-ids';

export function WishListButton() {
  const count = useWishListCount();
  const [runAnimation, setRunAnimation] = React.useState(false);
  const wishListPageUrl = useDynamicData<NordicNest.Api.WellknownPagesApiModel>()[0]?.wishListPageUrl || '';

  React.useEffect(() => {
    setRunAnimation(true);
  }, [count]);

  return (
    <IconButton
      to={wishListPageUrl}
      disableRippleEffect
      square
      as={Theme.Transparent}
      aria-label={translate(t => t.header.favorites)}
      onClick={() =>
        addNavigationEventToDataLayer({ to: wishListPageUrl, menu_type: 'header', menu_category: 'wishlist' })
      }
    >
      <HeartIcon {...TestIdProps.MyWishlistLink} />
      {count > 0 && (
        <ItemCount
          css={runAnimation && pulseAnimationDecorator}
          onAnimationEnd={() => setRunAnimation(false)}
          {...NnTestIdProps.HeaderMyWishlinkIconCount}
        >
          {count}
        </ItemCount>
      )}
    </IconButton>
  );
}

const pulseAnimationDecorator = styled({
  animation: {
    name: {
      '0%': {
        boxShadow: t => `0 0 0 0 ${t.headerIndicators.favourites.backgroundColor}61`,
      },
      '70%': {
        boxShadow: t => `0 0 0 10px ${t.headerIndicators.favourites.backgroundColor}00`,
      },
      '100%': {
        boxShadow: t => `0 0 0 0 ${t.headerIndicators.favourites.backgroundColor}00`,
      },
    },
    duration: 2000,
  },
});

const IconButton = styled(ButtonLink, {
  position: 'relative',
  overflow: 'visible',
});

const ItemCount = styled.span({
  backgroundColor: t => t.headerIndicators.favourites.backgroundColor,
  color: t => t.headerIndicators.favourites.color,
  position: 'absolute',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: 20,
  width: 20,
  top: 4,
  right: 4,
  borderRadius: '50%',
  fontSize: t => t.sharedFontSize.xxxs,
});
